import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedFetch } from './useAuth'

export function useFolderArchived(folderId?: string) {
  const fetcher = useAuthenticatedFetch()
  const enabled = Boolean(folderId)

  const query = useQuery<boolean>({
    queryKey: ['folder', folderId, 'archived'],
    enabled,
    queryFn: async () => {
      try {
        const r = await fetcher(`/api/folders/${folderId}`)
        if (!r.ok) return false
        const j = await r.json()
        return Boolean(j?.folder?.archived)
      } catch {
        return false
      }
    },
    staleTime: 30_000,
  })

  return { archived: query.data ?? false, isLoading: query.isLoading }
}
